import { generatePath, useHistory } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { useSelectedObjectTypeId } from '../objectTypeIdContext/hooks/useSelectedObjectTypeId';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MissingViewError = () => {
  const objectTypeId = useSelectedObjectTypeId();
  const history = useHistory();
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "notFound",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "MISSING_VIEW"
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "index.errorBoundaries.missingView.nowhereToBeFound"
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: () => history.push(generatePath('/objects/:objectTypeId', {
        objectTypeId
      })),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "index.errorBoundaries.missingView.loadDefaultView"
      })
    })]
  });
};
export default MissingViewError;